module.exports = __webpack_public_path__ + "img/item3-m.c5680ce0.png";